import { useEffect } from 'react';
import { check } from '../actions';
import { useDispatch, useSelector } from 'react-redux';

export const useCheckUser = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(state => state.auth);

  useEffect(() => {
    async function checkUser() {
      dispatch(check());
    }

    if (isAuthenticated) {
      checkUser();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return null;
};
